import React from "react";

const FlowBackground = () => (
  <div className="flow-bg" aria-hidden="true" data-testid="flow-background">
    <span className="b1" />
    <span className="b2" />
    <span className="b3" />
    <span className="b4" />
  </div>
);

export default FlowBackground;
